var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddOrganisation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Add_Organisation",
    "data-name": "Add Organisation",
    transform: "translate(-756 -350)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60258",
    "data-name": "Group 60258"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4780",
    "data-name": "Ellipse 4780",
    cx: 11,
    cy: 11,
    r: 11,
    transform: "translate(756 350)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "add_circle_FILL1_wght400_GRAD0_opsz48",
    d: "M12.564,17.775h1.378V13.964h3.834V12.587H13.941V8.592H12.564v3.995H8.592v1.378h3.972Zm.62,4.592a8.886,8.886,0,0,1-3.559-.723,9.252,9.252,0,0,1-4.9-4.9,9.173,9.173,0,0,1,0-7.14A9.178,9.178,0,0,1,6.7,6.686,9.414,9.414,0,0,1,9.625,4.723a9.173,9.173,0,0,1,7.14,0A9.169,9.169,0,0,1,21.644,9.6a9.173,9.173,0,0,1,0,7.14,9.414,9.414,0,0,1-1.963,2.927,9.178,9.178,0,0,1-2.916,1.974A8.942,8.942,0,0,1,13.183,22.367Z",
    transform: "translate(753.816 347.633)",
    fill: "#005ca3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddOrganisation);
export default __webpack_public_path__ + "static/media/Add Organisation.2fecb4b6862d068381ca0516e981c295.svg";
export { ForwardRef as ReactComponent };